const shopCollectionRootEl = document.getElementById('shopCollectionApp');
const shopCollectionComponent = {
    props: {
        categories: Array,
        cards: Array,
        type: String,
        section: String
    },
    inject: ['loading'],
    created() {

    },
    computed: {
        cardsInterval() {
            if(this.section === 'subjects') {
                return Math.floor(this.categories.length/(this.cards.length - 1));
            } else {
                return Math.floor(this.categories.length/2) + 1;
            }
        }
    },
    methods: {
        canInsertCards(index) {
            if(this.cards.length > 0 && this.cardsInterval > 0 && this.categories.length > this.cardsInterval) {
                const position = ((index + 1)%this.cardsInterval) === 0 ? (index + 1)/this.cardsInterval : 0;
                return (position > 0 && position <= this.cards.length) ? position : 0;
            }
        },
        getCard(index) {
            if(this.section === 'subjects') {
                if((index-1) < this.cards.length) {
                    return this.cards[(index-1)];
                }
            } else {
                const lastCard = this.cards[(this.cards.length - 1)];
                return lastCard;
            }
        },
        categoryName(category) {
            return category.hasOwnProperty('shop_page_title') && category.shop_page_title !== null && category.shop_page_title !== '' ? category.shop_page_title : category.name;
        }
    },
    template: `<template v-if="loading">
        <li v-for="n in 30" :key="n" class="item">
          <div class="placeholder-container">
            <div class="content">
            </div>
          </div>
        </li>
      </template>
      <template v-for="(category,index) in categories" :key="category.id">
        <li class="item">
            <div class="shop-cat-wrap">
                <a :href="category.url" class="coll-shop-img">
                    <img loading="lazy" :src="category.image" :alt="category.name" />
                </a>
                <div class="shop-cat-details">
                    <h2><a :href="category.url" class="product-name" v-html="categoryName(category)"></a></h2>
                    <p>{{category.description}}</p>
                </div>
                <div class="subcategories" v-if="category.sub_categories.length > 0">
                    <div class="sub-item shop-all">
                        <a :href="category.url" class="product-image"><img loading="lazy" :src="category.thumb" :alt="category.name" /></a>
                        <h3><a :href="category.url" class="product-name">Shop All</a></h3>
                    </div>
                    <div class="sub-item" v-for="subcategory in category.sub_categories" :key="subcategory.id">
                        <a :href="subcategory.url" class="product-image"><img loading="lazy" :src="subcategory.thumb" :alt="subcategory.name" /></a>
                        <h3><a :href="subcategory.url" class="product-name" v-html="categoryName(subcategory)"></a></h3>
                    </div>
                </div>
            </div>
        </li>
        <template v-if="canInsertCards(index)">
        <li class="item" v-html="getCard(canInsertCards(index))"></li>
        </template>
      </template>`
}
const shopProductComponent = {
    components: {
        'wishlistlink': wishlistLink
    },
    data() {
        return {
            imageRatio: '1',
            mouseOver: false,
            smallestCanvasSize: null
        }
    },
    inject: ['discount','productSizes','productMaterials'],
    emits: ['quickview','openSampleModal'],
    created() {
    },
    mounted() {
        if(this.product.dmi_image_url) {
            const img = new Image();
            img.src = this.product.dmi_image_url;
        } else if(this.product.images && this.product.images.length > 1) {
            const img = new Image();
            img.src = this.product.images[1];
        }
    },
    template: `<a v-bind:href="getUrl(product,productType)" @mouseenter="mouseOver = true" @mouseleave="mouseOver = false">
                <span class="product-image" v-if="dmiImageUrl">
                  <Transition name="image" mode="out-in">
                    <img :src=imageUrl alt="" loading="lazy" v-if="!mouseOver">
                    <img :src=dmiImageUrl alt="" v-else-if="mouseOver">
                  </Transition>
                </span>
                <span class="product-image" v-else>
                  <img :src=imageUrl alt="" loading="lazy">
                </span>
                <span class="item-content">
                <span class="item-name">
                    <span class="link-view">{{productTitle}}</span>
                    <button class="quickview" @click.stop.prevent="quickview()"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#939393" class="bi bi-zoom-in" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/></svg><span class="sr-only">View Larger</span></button>
                    <wishlistlink :id="product.id" :type="productType" :url="getUrl(product,productType)" :image="imageUrl" :title="productTitle"></wishlistlink>
                </span>
                <span class="canvas-size" v-if="this.type === 'canvas' && this.smallestCanvasSize"><em v-html="smallestCanvasSize.size"></em> <span>multiple sizes</span></span>
                <span class="price-container" v-if="this.type === 'canvas' && this.smallestCanvasSize">
                    <label>From</label>
                    <span class="prices">
                        <span class="special-price">{{formatCurrency(specialPrice)}}</span>
                        <span class="old-price">{{formatCurrency(price)}}</span>
                        <span class="discount">{{discount}}% off</span>
                    </span>
                </span>
                <span class="add-to-links"><span class="product-button">Choose Options</span><button class="product-button" v-if="type !== 'canvas'" @click.stop.prevent="openSampleModal()">Order Sample</button></span>
                </span>
              </a>`,
    props: {
        product: Object,
        type: String
    },
    computed: {
        imageUrl() {
            return (this.type === 'canvas') ? (this.product.shopify ? this.product.thumbnail_url : this.previewUrl + this.product.thumbnail_url) : this.product.thumbnail_url;
        },
        dmiImageUrl() {
            return this.product.dmi_image_url ? this.product.dmi_image_url : (this.product.images && this.product.images.length > 1) ? this.product.images[1] : null;
        },
        productType() {
            let title = this.product.title.toLowerCase().replace(/\./g, ' ');
            if(this.type !== 'canvas' && title.indexOf('wallpaper') !== -1) {
                return 'wallpaper';
            }
            return this.type;
        },
        productTitle() {
            let title = this.product.title.toLowerCase().replace(/\./g, ' ');
            if(this.type === 'canvas') {
                if(title.indexOf('canvas print') === -1) {
                    title += ' canvas print';
                }
            } else {
                if(title.indexOf('wallpaper') === -1) {
                    if(title.indexOf('wall mural') === -1) {
                        title += ' wall mural';
                    }
                }
            }
            return title;
        },
        price() {
            return this.smallestCanvasSize ? this.smallestCanvasSize.price : '';
        },
        specialPrice() {
            return this.smallestCanvasSize ? this.smallestCanvasSize.price * (1 - (Number(this.discount) / 100)) : '';
        },
    },
    methods: {
        onLoad() {
            const img = new Image();
            img.onload = () => {
                const width = img.width
                const height = img.height
                this.imageRatio = this.getAspectRatio(width, height);
                this.smallestCanvasSize = this.canvasSize();
            }
            img.src = this.product.thumbnail_url
        },
        canvasSize() {
            if(this.type === 'canvas') {
                const size = this.productSizes.find(size => {
                    if(this.imageRatio === '3') {
                        return (
                            size.rendered_size === 'medium' &&
                            size.aspect_ratio === this.imageRatio
                        )
                    } else {
                        return (
                            size.rendered_size === 'small' &&
                            size.aspect_ratio === this.imageRatio
                        )
                    }
                })
                return size;
            }
        },
        quickview() {
            this.$emit('quickview', [this.product, this.productTitle, this.productType]);
        },
        openSampleModal() {
            this.$emit('openSampleModal', this.product);
        },
    }
}
if(shopCollectionRootEl) {
    const shopCollectionApp = Vue.createApp({
        components: {
            'collection': shopCollectionComponent,
            'product': shopProductComponent,
            'materials-compare': materialsModalCompare
        },
        data() {
            return {
                subjects: [],
                rooms: [],
                loading: false,
                products: [],
                cardsInterval: 0,
                cards: [],
                showAllSubjects: false,
                productSizes: null,
                productMaterials: null,
                productLoading: false,
            }
        },
        props: ['type','id','discount','partnerDiscount'],
        provide() {
            return {
                loading: Vue.computed(() => this.loading),
                productSizes: Vue.computed(() => this.productSizes),
                productMaterials: Vue.computed(() => this.productMaterials),
                discount: (this.partnerDiscount && window.customerIsPartner) ? this.partnerDiscount : this.discount,
                productLoading: Vue.computed(() => this.productLoading),
            }
        },
        created() {
            this.cardsInterval = window.limitlesswallsCardsInterval || 0;
            this.cards = window.limitlesswallsCards || [];
        },
        mounted () {
            if(this.type === 'wallpaper' || this.type === 'mural' || this.type === 'canvas') {
                this.loadShopifyCollection();
            } else {
                this.loadMagentoCollection();
            }
        },
        computed: {
            cardsSize() {
                return this.cards.length;
            }
        },
        methods: {
            loadShopifyCollection() {
                this.loading = true;
                if(this.type === 'canvas') {
                    this.productSizes = JSON.parse(document.getElementById('product-sizes-json').textContent);
                } else {
                    this.productMaterials = JSON.parse(document.getElementById('product-materials-json').textContent);
                }
                this.products = JSON.parse(this.sanitizeTextContent(document.getElementById('shopifyCollectionResults')));
                this.loading = false;
            },
            loadMagentoCollection() {
                this.loading = true;
                let url = this.type === 'canvas' ? '/products/canvas' : '/products/mural';
                url += '?sections=api-product-data';
                axios.get(url).then((response) => {
                    if (response && response.hasOwnProperty('data') && response.data.hasOwnProperty('api-product-data')) {
                        const html = response.data['api-product-data'];
                        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                        if (this.type === 'canvas') {
                            this.productSizes = JSON.parse(parsedHTML.getElementById('product-sizes-json').textContent);
                        } else {
                            this.productMaterials = JSON.parse(parsedHTML.getElementById('product-materials-json').textContent);
                        }
                    }
                    let collectionUrl = this.remoteApiUrl + 'shopify/collection/shop?isAjax=1&type=' + this.type;
                    return axios.get(collectionUrl);
                }).then((response) => {
                    if (response && response.hasOwnProperty('data')) {
                        if (response.data.hasOwnProperty('subjects')) {
                            this.subjects = response.data.subjects;
                        }
                        if (response.data.hasOwnProperty('rooms')) {
                            this.rooms = response.data.rooms;
                        }
                        if (response.data.hasOwnProperty('products')) {
                            this.products = response.data.products;
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            openSampleModal(product) {
                product = (typeof product === 'undefined') ? false : product;
                if(!product) {
                    product = sessionStorage.getItem('last-sample-product');
                    if(product) {
                        product = JSON.parse(product);
                    }
                }
                if(!product) {
                    return;
                }
                sessionStorage.setItem('last-sample-product', JSON.stringify(product));
                product = this.cloneObject(product);
                this.productLoading = product.id;
                product.type = this.type;
                product.isGridItem = true;
                product.productUrl = this.getUrl(product,this.type);
                const promiseLargeImage = new Promise((resolve, reject) => {
                    if(product.entity_id || product.shopify) {
                        resolve(product);
                    } else if(sessionStorage.getItem('adobe-image-'+product.id)) {
                        product.thumbnail_url = sessionStorage.getItem('adobe-image-'+product.id);
                        resolve(product);
                    } else {
                        let url = this.remoteApiUrl + 'shopify/api/download?id='+product.id;
                        return fetch(url).then((response) => { return response.json(); }).then((response) => {
                            if(response.url) {
                                product.thumbnail_url = response.url;
                                sessionStorage.setItem('adobe-image-'+product.id, response.url);
                            }
                        }).finally(() => {
                            resolve(product);
                        })
                    }
                }).then((product) => {
                    const img = new Image();
                    img.onload = () => {
                        this.productLoading = null;
                        const width = img.width
                        const height = img.height
                        product.imageWidth = width;
                        product.imageHeight = height;
                        store.dispatch('samplePopup/set', {'item': product, 'croppedFile': null, 'files': null});
                        store.dispatch('samplePopup/open');
                    }
                    img.src = product.thumbnail_url;
                })
            },
            downloadAsset([product,description,type]) {
                try {
                    this.productLoading = product.id;
                    const downloadedPromise = new Promise((resolve, reject) => {
                        if(product.entity_id) {
                            const data = {
                                'image': product.thumbnail_url,
                                'url': this.getUrl(product,type),
                                'description': description
                            };
                            resolve(data);
                        } else if(product.hasOwnProperty('shopify') && product.shopify) {
                            const productUrl = '/products/' + product.url;
                            const data = {
                                'image': product.thumbnail_url,
                                'url': productUrl,
                                'description': description
                            };
                            resolve(data);
                        } else {
                            if(sessionStorage.getItem('adobe-image-'+product.id)) {
                                const largeImage = sessionStorage.getItem('adobe-image-'+product.id);
                                const productUrl = this.getProductUrl({image: largeImage, id: product.id, title: description});
                                const data = {
                                    'image': largeImage,
                                    'url': productUrl,
                                    'description': description
                                };
                                resolve(data);
                            } else {

                                let url = this.remoteApiUrl + 'shopify/api/download?id='+product.id;
                                axios.get(url).then((response) => {
                                    if(response.data && response.data.url) {
                                        sessionStorage.setItem('adobe-image-'+product.id, response.data.url);
                                        const productUrl = this.getProductUrl({image: response.data.url, id: product.id, title: description});
                                        const data = {
                                            'image': response.data.url,
                                            'url': productUrl,
                                            'description': description
                                        };
                                        resolve(data);
                                    } else {
                                        reject();
                                    }
                                })
                            }

                        }
                    }).then((data) => {
                        const modalBody =
                            `<div class="image"><img src="${data.image}" alt=""></div>`;
                        let modalFooter =
                            `<div class="info">
                                <div class="product">
                                    <p class="name">${data.description}</p>
                                </div>
                            </div>
                            `;
                        if(type === 'mural' || type === 'wallpaper') {
                            modalFooter += `<div class="actions canvas-extra">
                                <a href="${data.url}" class="action action--compare extra-link"><span>Choose Options</span><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></a>
                                <button type="button" class="action action--submit button extra-link open-sample-modal-trigger"><span>Order Sample | $10</span>
                                    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>
                                </button>
                            </div>`
                        } else {
                            modalFooter += `<div class="actions canvas-extra">
                                <a href="${data.url}" class="action action--compare extra-link"><span>Choose Options</span><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></a></div>`
                        }
                        product = this.cloneObject(product);
                        product.type = this.collectionType;
                        product.isGridItem = true;
                        product.productUrl = data.url;
                        product.thumbnail_url = data.image;
                        sessionStorage.setItem('last-sample-product', JSON.stringify(product));
                        store.dispatch('modal/set', {
                            'modalClass': 'quickview-modal',
                            'modalBody': modalBody,
                            'modalFooter': modalFooter
                        })
                        this.openModal();
                    }).finally(() => {
                        this.productLoading = null;
                    });

                } catch (e) {
                    console.error(e);
                }
            },
            quickview([product,description,type]) {
                this.downloadAsset([product,description,type]);
            },
            getProductUrl(params) {
                const title = btoa(params.title);
                let url = '/products/'+this.type+'?imageId=' + params.id + '&title=' + title;
                try {
                    url = '/products/'+this.type+'?image=' + btoa(params.image) + '&imageId=' + params.id + '&title=' + title;
                } catch (e) {
                    console.error(e);
                }
                return url;
            },
            openModal() {
                store.dispatch('modal/open')
            },
            closeModal() {
                store.dispatch('modal/close')
            },
            openCompareModal() {
                store.dispatch('modal/openComparePopup');
            },
            closeCompareModal() {
                store.dispatch('modal/closeComparePopup');
            },
            canInsertCards(index) {
                if(this.cards.length > 0 && this.cardsInterval > 0 && this.products.length > this.cardsInterval) {
                    // Determine which insertion "slot" this is (1,2,3,...)
                    const isBoundary = ((index + 1) % this.cardsInterval) === 0;
                    if (!isBoundary) return 0;
                    const rawPosition = (index + 1) / this.cardsInterval; // 1,2,3,...
                    const size = this.cardsSize || 0;
                    if (size === 0) return 0;
                    // Wrap position into 1..size so cards repeat after reaching the last one
                    const wrapped = ((rawPosition - 1) % size) + 1;
                    return wrapped;
                }
            },
            getCard(index) {
                const size = this.cardsSize || 0;
                if (!size || !index || index <= 0) return '';
                // Normalize any index (e.g. 6,7,...) into 1..size
                const wrappedIndex = ((index - 1) % size) + 1;
                if (this.cards[(wrappedIndex - 1)] === undefined) {
                    return '';
                }
                let card = this.cards[(wrappedIndex - 1)];
                let keyword = this.type.toLowerCase();
                let keywordP = (keyword === 'canvas') ? 'canvases' : keyword + 's';
                card = card.replace(/wall murals/g,keywordP);
                card = card.replace(/murals/g,keywordP);
                card = card.replace(/wall mural/g,keyword);
                if(this.type.toLowerCase() !== 'nural') {
                    card = card.replace(/mural/g,keyword);
                }
                return card;
            }
        }
    }, { ...shopCollectionRootEl.dataset })
    shopCollectionApp.use(AdobeClientPlugin).use(store);
    shopCollectionApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches') && !tag.includes('materials-compare')
    shopCollectionApp.config.unwrapInjectedRef = true
    shopCollectionApp.mount('#shopCollectionApp');
}
